import Loader from '@/components/loader/Loader.vue'
import Dropdown from '@/components/dropdown/Dropdown.vue'
import InputText from '@/components/inputText/InputText.vue'
import DropdownSelect from '@/components/dropdownSelect/DropdownSelect.vue'
import Modal from '@/components/modal/Modal.vue'
import regex from '@/common/regex'

export default {
    name: 'Auth',
    inject: ['auth', 'localization'],
    data () {
        return {
            mode: 'new',
            users: [],
            loading: false,
            authError: false,
            form: {
                object: {
                    control: 'input-text',
                    value: null,
                    placeholder: 'Object',
                    mode: 'new',
                    alias: 'object',
                },
                login: {
                    control: 'input-text',
                    value: null,
                    validator: { required: true, disableRoot: true },
                    placeholder: 'Login',
                },
                password: {
                    control: 'input-text',
                    type: 'password',
                    value: null,
                    validator: { required: true, },
                    placeholder: 'Password',
                },
                remember: {
                    control: 'checkbox',
                    value: true,
                    trueValue: true,
                    falseValue: false,
                    label: 'Save credentials',
                    mode: 'new',
                },
            },
            forgot: {
                show: false,
            },
            lang: {
                active: null,
                list: [
                    { name: 'en', title: 'EN' },
                    { name: 'ru', title: 'Рус' },
                ]
            }
        }
    },
    created() {
        let usersJson = localStorage.getItem('users')

        if (usersJson) {
            this.users = JSON.parse(usersJson)
        }

        if (this.users.length) {
            this.form.object.value = this.users[0].object
            this.form.login.value = this.users[0].login
        }

        this.lang.active = this.lang.list.find(item => item.name === this.$store.state.i18n.locale)

        this.$validator.extend('disableRoot', {
            getMessage: field => 'disableRoot',
            validate: (value) => {
                return value.toLowerCase() !== 'root'
            }
        })
    },
    computed: {
        formData() {
            return {
                object: this.form.object.value,
                login: this.form.login.value,
                password: this.form.password.value,
                remember: this.form.remember.value,
            }
        },
    },
    watch: {
        form: {
            handler(form) {
                this.errors.items.forEach(item => {
                    this.errors.removeById('backend')
                })
            },
            deep: true,
        },
    },
    methods: {
        login: function() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.loading = true

                    this.auth.login(this.formData).then(() => {
                        this.loading = false
                        this.$router.push({ name: 'views', params: { viewId: 'main'} })
                    }, (e) => {
                        if (e.status === 400) {
                            this.errors.add({ field: 'password', msg: 'auth', id: 'backend', })
                        }

                        this.loading = false
                    })
                }
            });
        },
    },
    components: {
        Loader,
        Dropdown,
        DropdownSelect,
        InputText,
        Modal,
    }
}



// WEBPACK FOOTER //
// ./src/modules/auth/auth.js